export default __webpack_public_path__ + "static/media/img1.a1ca8789.svg";